import { request } from "../../utils/config"

export const GET_MANAGERS = async (params) => {
  const response = await request({
    url: `Managers`,
    params: params,
    Headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_ALL_MANAGERS = async (params) => {
  const response = await request({
    url: `Managers`,
    params: { ...params, PageSize: 10000000 },
    Headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const GET_MANAGER = async (id: number) => {
  const response = await request({
    url: `Managers/${id}`,
    Headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
